import { Component, OnInit, Input, Output, EventEmitter, Optional, Inject, OnChanges } from '@angular/core';
import {
  CorrespondenceDataObj,
  ITemplate,
  ISaveCorrespondenceActivity,
  DataIds,
  CorrespondenceActivity,
  Venue,
  IPlaceholderMap,
} from '../../../shared/models/activity-dashboard-model';
import { ActivityService } from '../../../core/services/activity.service';
import { AssociateService } from '../../schedulerpersona/services/associate.service';
import { FileService } from '../../../core/services/file.service';
import { Template } from '../../../shared/models/createschedule';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivityDialogComponent } from '../activity-dialog/activity-dialog.component';

import { SchedulerCandidate, ActivitiesOnCandidate } from '../../../shared/models/schedulerAssociate';
export interface Status {
  value: string;
}

@Component({
  selector: 'activity-correspondence',
  templateUrl: './activity-correspondence.component.html',
  styleUrls: ['./activity-correspondence.component.scss'],
  standalone: false,
})
export class ActivityCorrespondenceComponent implements OnInit, OnChanges {
  editactivity: any = false;
  userloggedin: any;
  loginUserName: any;
  @Output() singleformValid: EventEmitter<boolean> = new EventEmitter();
  clauseId: number;

  constructor(
    private activityService: ActivityService,
    private fileService: FileService,
    private associateService: AssociateService,
    public dialogRef: MatDialogRef<ActivityDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.correspondenceDataObj = data.correspondenceDataObj;
      this.editactivity = data.editActivity;
      this.isCollapsed = data.editActivity;
      this.candidateEmails = data.candidateEmails;
    }
  }

  placeholderMapping: any[] = [];

  public ccEnable: boolean = false;
  public bccEnable: boolean = false;

  public isCollapsed: boolean = false;

  //time
  public timeModifiedOn: string;
  templateData: ITemplate[];

  // file upload
  allowedTypes = '.doc,docx,.xls,xlsx,.pdf,.jpg,.jpeg,.msg,.png';
  multiple = 'multipleSelect';
  fileDemoData: any;
  single = 'single';
  editId: any;
  fileData: any;
  deletedFile: any;
  companyHiringType: any; //= 1;
  templateIndex: any;
  toggleBtn: boolean = false;
  @Input() selectedTemplate: any;
  @Input() InterviewTemplateData: ITemplate[];
  @Input() interviewFlag: boolean;
  comments: string = 'ABC';
  ids: DataIds;
  @Input() candidateApplicationIds: number[];
  @Input() correspondenceDataObj: CorrespondenceDataObj;
  @Input() ifCoupled: boolean;
  @Input() candidateEmails: string[];
  @Input() selectedCandidate: SchedulerCandidate[];
  @Input() selectedClauseIndex: any;

  templateDisable: boolean = false;
  template: Template[];
  bccInputValue: string;
  ccInputValue: string;
  subjectInputValue: string;
  toInputValue: string;
  remarksInputValue: string;
  bodyInputValue: string;
  candidateData: ActivitiesOnCandidate;
  candidateMail: any = [];
  templateId: number;
  toDisable: boolean = false;
  @Input() placeholderMappingInterview: any[];
  @Input() selectedVenue: Venue;
  @Input() interviewDate: any;
  @Input() interviewTime: any;

  placeholderObject: IPlaceholderMap;
  showActivityUI: boolean = true;
  @Output() refreshcandiates: EventEmitter<any> = new EventEmitter();
  ngOnInit() {
    this.isCollapsed = true;

    this.companyHiringType = localStorage.getItem('fresherCompHiringTypeId');
    console.log('selcted candidate array', this.selectedCandidate);

    if (
      this.correspondenceDataObj &&
      (this.correspondenceDataObj.activityId === 600101 || this.correspondenceDataObj.activityId === 600102) &&
      this.selectedCandidate &&
      this.selectedCandidate.length > 0
    ) {
      const requiresSFOValidation =
        ['2', '4', '9'].includes(this.companyHiringType) ||
        (this.correspondenceDataObj.activityId === 600102 && !['1', '2', '4'].includes(this.companyHiringType));

      if (requiresSFOValidation) {
        this.activityService
          .getSFO(
            this.selectedCandidate[0].candidateId,
            this.companyHiringType,
            this.selectedCandidate[0].applicationId,
          )
          .subscribe((sfodata) => {
            if (sfodata !== 'Success') {
              this.showActivityUI = false;
              const data = {
                msg: sfodata,
                isSuccess: false,
              };
              this.activityService.openSnackBar(data, 'danger-snack');
              if (this.dialogRef) {
                this.dialogRef.close();
              }
              return;
            }
            this.initializeComponent();
          });
        return;
      }
    }
    this.initializeComponent();
  }

  private initializeComponent() {
    //  if(!this.interviewFlag)
    //  {
    //    if(!this.editactivity)
    //    {
    //  this.selectedCandidate.forEach(value=>{

    //   this.associateService.getActivitiesOnCandidate(value.applicationId,value.candidateId).subscribe(data=>
    //     {
    //       console.log("placeholder",data);
    //       this.candidateData=data;

    //       let obj=
    //         {

    //         fname:this.candidateData.fname,
    //         lname:this.candidateData.lname,
    //         candidateId:value.candidateId,
    //           //this.correspondenceDataObj.candidateName
    //         }

    // let obj : IPlaceholderMap;
    // obj.fname=this.candidateData.fname,
    // obj.lname=this.candidateData.lname,
    // obj.candidateId=value.candidateId,
    //         this.placeholderMapping.push(obj);
    //         this.candidateMail.push(value.email);
    //     })

    //   });
    // }
    // else{
    //   console.log("edit selected candidate--",this.correspondenceDataObj);
    //   this.associateService.getActivitiesOnCandidate(this.correspondenceDataObj.applicationId,this.correspondenceDataObj.candidateId).subscribe(data=>
    //     {
    //       console.log("placeholder",data);
    //       this.candidateData=data;

    //       let obj=
    //         {

    //         fname:this.candidateData.fname,
    //         lname:this.candidateData.lname,
    //         candidateId:this.correspondenceDataObj.candidateId,
    //           //this.correspondenceDataObj.candidateName
    //         }

    //       // let obj : IPlaceholderMap;
    //       // obj.fname=this.candidateData.fname,
    //       // obj.lname=this.candidateData.lname,
    //       // obj.candidateId=value.candidateId,
    //         this.placeholderMapping.push(obj);
    //         this.candidateMail.push(this.candidateEmails[0]);
    //     })
    //     console.log("edit placeholder---",this.placeholderMapping);
    // }
    //  }
    console.log('placholder ngonint', this.placeholderMapping);

    console.log(this.companyHiringType);

    this.userloggedin = JSON.parse(localStorage.getItem('loggedInUser'));
    console.log('loginuser---->', this.userloggedin);

    this.loginUserName = this.userloggedin.username;
    console.log(this.loginUserName);

    console.log('this.correspondance data obj', this.correspondenceDataObj);
    // this.editId = { objectId: this.correspondenceDataObj.applicationId, objectType: 'AP' };
    console.log(this.candidateEmails);

    this.toInputValue = this.candidateEmails[0];
    this.toDisable = true;

    console.log(this.interviewFlag);
    if (!this.interviewFlag) {
      this.selectedTemplate = -1;

      this.subjectInputValue = '';
      this.bodyInputValue = '';
      this.remarksInputValue = '';
      this.ccInputValue = '';
      this.bccInputValue = '';
    }

    if (this.correspondenceDataObj && this.correspondenceDataObj.activityId && this.correspondenceDataObj.processId) {
      this.activityService
        .getTemplate(this.correspondenceDataObj.activityId, this.correspondenceDataObj.processId)
        .subscribe((data) => {
          this.templateData = data;
          console.log(this.templateData);
        });
    }

    if (this.editactivity && !this.interviewFlag) {
      console.log('corresp obj----', this.correspondenceDataObj);
      this.editId = {
        objectId: this.correspondenceDataObj.applicationId,
        objectType: 'AP',
        activityId: this.correspondenceDataObj.activityId,
      };
      if (this.correspondenceDataObj && this.correspondenceDataObj.activityId && this.correspondenceDataObj.processId) {
        this.activityService
          .getTemplate(this.correspondenceDataObj.activityId, this.correspondenceDataObj.processId)
          .subscribe((data) => {
            this.templateData = data;

            if (this.templateData) {
              this.selectedTemplate = this.templateData[0].templateId;
              this.getTemplateData(this.selectedTemplate);
            }
            this.getActivity(this.correspondenceDataObj);
            console.log(this.templateData);
          });
      }

      // .applicationId, this.correspondenceDataObj.activityId, this.correspondenceDataObj.processId);
    }
    console.log('slected candidate application--->', this.candidateApplicationIds);
    //  let p = this.displayText("mr. abc <<fname>>")
  }

  ngOnChanges() {
    console.log(this.interviewDate);

    this.toInputValue = this.candidateEmails[0];
    console.log('interviewflag---', this.interviewFlag);
    //   if(this.interviewFlag)
    //   {
    //     if(!this.editactivity)
    //     {
    //   this.selectedCandidate.forEach(value => {
    //     if(value.applicationId && value.candidateId)   {

    //    console.log("inside service")
    //     this.associateService.getActivitiesOnCandidate(value.applicationId, value.candidateId).subscribe(data => {
    //       console.log("placeholder", data);
    //       this.candidateData = data;
    //       let obj =
    //       {
    //         fname: this.candidateData.fname,
    //         lname: this.candidateData.lname,
    //         candidateID: value.candidateId,
    //         venueAddress:this.selectedVenue.venueName,
    //         interviewDate:this.interviewDate,
    //         interviewTime:this.interviewTime,
    //         interviewDuration:"4 Hrs"

    //         //this.correspondenceDataObj.candidateName
    //       }

    //       // let obj : IPlaceholderMap;
    //       // obj.fname=this.candidateData.fname,
    //       // obj.lname=this.candidateData.lname,
    //       // obj.candidateId=value.candidateId,
    //       this.placeholderMapping.push(obj);
    //       this.candidateMail.push(value.email);

    //   if (this.interviewFlag) {
    //     this.templateDisable = true;

    //     if (this.selectedClauseIndex >= 0) {

    //       let p =this.displayText(this.InterviewTemplateData[this.selectedClauseIndex].templateBody,0);

    //       this.bodyInputValue=p;
    //       this.subjectInputValue = this.InterviewTemplateData[this.selectedClauseIndex].templateSubject;
    //     }
    //   }
    //     })
    //   }
    //   });
    // }
    //   else{
    //     this.associateService.getActivitiesOnCandidate(this.correspondenceDataObj.applicationId,this.correspondenceDataObj.candidateId).subscribe(data => {
    //       console.log("placeholder", data);
    //       this.candidateData = data;
    //       let obj =
    //       {
    //         fname: this.candidateData.fname,
    //         lname: this.candidateData.lname,
    //         candidateID: this.correspondenceDataObj.candidateId,
    //         venueAddress:this.selectedVenue.venueName,
    //         interviewDate:this.interviewDate,
    //         interviewTime:this.interviewTime,
    //         interviewDuration:"4 Hrs"

    //         //this.correspondenceDataObj.candidateName
    //       }

    //       // let obj : IPlaceholderMap;
    //       // obj.fname=this.candidateData.fname,
    //       // obj.lname=this.candidateData.lname,
    //       // obj.candidateId=value.candidateId,
    //       this.placeholderMapping.push(obj);
    //       this.candidateMail.push(this.candidateEmails[0]);

    //   if (this.interviewFlag) {
    //     this.templateDisable = true;

    //     if (this.selectedClauseIndex >= 0) {

    //       let p =this.displayText(this.InterviewTemplateData[this.selectedClauseIndex].templateBody,0);

    //       this.bodyInputValue=p;
    //       this.subjectInputValue = this.InterviewTemplateData[this.selectedClauseIndex].templateSubject;
    //     }
    //   }
    //     })
    //   }

    //   console.log("interview---",this.placeholderMappingInterview)

    // }
    if (this.interviewFlag) {
      this.templateDisable = true;
      console.log('selectedclause---', this.selectedClauseIndex);
      if (this.selectedClauseIndex >= 0) {
        // let p =this.displayText(this.InterviewTemplateData[this.selectedClauseIndex].templateBody,0);

        this.bodyInputValue = this.InterviewTemplateData[this.selectedClauseIndex].templateBody;
        this.subjectInputValue = this.InterviewTemplateData[this.selectedClauseIndex].templateSubject;
      }
    }

    if (!this.interviewFlag) {
      this.selectedTemplate = -1;

      this.subjectInputValue = '';
      this.bodyInputValue = '';
      this.remarksInputValue = '';
      this.ccInputValue = '';
      this.bccInputValue = '';
    }
  }
  testformValid(flag) {
    // console.log('single form working', flag);

    this.singleformValid.emit(flag);
  }

  // toggle enable/disable CC in correspondace activity
  ccEnableDisable() {
    console.log(this.ccEnable);
    this.ccEnable = !this.ccEnable;
    console.log(this.ccEnable);
  }

  getTemplateData(event) {
    // Only update fields when user changes dropdown
    console.log('selected template id--', this.selectedTemplate);
    const templateId = event;
    this.templateIndex = this.templateData.findIndex((item) => item.templateId === templateId);
    if (this.templateIndex === -1) {
      console.warn('Template not found for templateId:', templateId);
      return;
    }
    this.templateId = this.templateData[this.templateIndex].templateId;
    this.clauseId = this.templateData[this.templateIndex].clauseid;
    this.bodyInputValue = this.templateData[this.templateIndex].templateBody;
    this.subjectInputValue = this.templateData[this.templateIndex].templateSubject;
  }

  // toggle enable/disable BCC in correspondace activity
  bccEnableDisable() {
    this.bccEnable = !this.bccEnable;
  }

  // expand/collapse action
  showMoreLess() {
    this.isCollapsed = !this.isCollapsed;
  }

  getActivity(obj: CorrespondenceDataObj) {
    //
    console.log('correspondence activity get activity', obj.createdOn);
    this.activityService
      .getCorrespondenceActivity(obj.applicationId, obj.activityId, obj.processId, obj.createdOn)
      .subscribe((response: CorrespondenceActivity) => {
        console.log(response);
        this.dataInitialization(response);
      });
  }

  dataInitialization(activityObj1) {
    if (activityObj1.createdOn === '') {
      //this.notes ='';
      //this.isDeleteDisable = true;
      console.log('IF_inside dataInitialization');
    } else {
      //this.notes = this.checkSuitabilityDataObj.simpleActivity.notes;
      //this.isDeleteDisable = false;
      // console.log("ELSE_inside dataInitialization");
      console.log(
        'ELSE_inside dataInitialization--activityobj',
        activityObj1,
        'clausemodel---',
        activityObj1.templateclauseModel.templateBody,
      );
      this.correspondenceDataObj.correspondenceActivity = activityObj1;
      this.comments = activityObj1.comments;
      this.remarksInputValue = activityObj1.comments;
      if (activityObj1.cc != '' && activityObj1.cc != null) {
        this.ccEnable = true;
      }
      if (activityObj1.bcc != '' && activityObj1.bcc != null) {
        this.bccEnable = true;
      }
      // this.ccEnable=true;
      // this.bccEnable=true;
      this.ccInputValue = activityObj1.cc;
      this.bccInputValue = activityObj1.bcc;
      // time

      this.timeModifiedOn = this.correspondenceDataObj.correspondenceActivity.modifiedOn;
      console.log(activityObj1);
      //template binding
      // this.selectedTemplate = activityObj1.templateclauseModel.templateId;
      this.templateIndex = this.templateData.findIndex((item) => item.clauseid === activityObj1.clause_id);
      this.templateId = this.templateData[this.templateIndex].templateId;
      this.selectedTemplate = this.templateId;
      console.log('templateid--', this.templateId, 'clauseid--', this.selectedTemplate);
      // let p =this.displayText(this.templateData[this.templateIndex].templateBody,0);
      // let p1=this.displayText("my name is <<fname>> and i live in city <<city>>")
      // this.bodyInputValue=p;
      // this.bodyInputValue = this.templateData[index].templateBody;
      this.bodyInputValue = activityObj1.templateclauseModel.templateBody;
      this.subjectInputValue = this.templateData[this.templateIndex].templateSubject;
    }
  }

  //put communication

  getFormValue() {
    console.log(this.ccInputValue);
  }
  send() {
    if (this.editactivity) {
      this.editCorresActivity();
    } else {
      this.saveCorresActivity();
    }
    // this.refreshcandiates.emit("true");
  }

  saveInterviewCorresActivity(processId, activityId, applicationId) {
    console.log(this.ccInputValue);
    console.log('inside saveInterview correspondence');
    console.log('placeholer--->', this.placeholderMapping, this.candidateEmails);

    // console.log(fd)

    this.saveAttachment(applicationId, this.companyHiringType, activityId);

    console.log(this.candidateEmails);

    this.associateService.recruiterActivity.subscribe((res) => {
      if (!res || !res.interviewMail) {
        return;
      }

      const postDataObj: ISaveCorrespondenceActivity = {
        applicationIds: this.candidateApplicationIds,
        processId: res.interviewMail.processId,
        activityId: res.interviewMail.activityId,
        comments: this.remarksInputValue,
        clause_id: this.clauseId,
        mailerID: 1010,
        // "clausMasterList": null,
        cc: this.ccInputValue,
        bcc: this.bccInputValue,
        templateId: this.templateId,
        mobileRequest: false,
        eventId: null,
        templateSubject: this.subjectInputValue,
        templateBody: this.bodyInputValue,
      };
      console.log('savecoress obj for interview---', postDataObj);
      if (postDataObj && postDataObj.applicationIds && postDataObj.activityId && postDataObj.processId) {
        this.activityService.saveCorrespondenceActivity(postDataObj).subscribe((res) => {
          console.log(res);
        });
      }
    });

    //mailer integration
    // for (let i = 0; i < this.candidateEmails.length; i++) {

    //   console.log("index of mail-->", i);
    //   const fd = new FormData();
    //   fd.append('from', 'talentacquisition@infosys.com')
    //   fd.append('subject', this.subjectInputValue);

    //   if (this.ccInputValue != null) {
    //     fd.append('ccArray', this.ccInputValue)
    //   }

    //   if (this.fileData != null) {
    //     this.fileData.forEach(file => {
    //       fd.append('file[' + file.name + ']', file);

    //     });
    //   }
    //   fd.append('to', this.candidateEmails[i]);
    //   let p = this.displayText(this.InterviewTemplateData[this.selectedClauseIndex].templateBody, i);
    //   fd.append('body', p)

    //   this.activityService.sendEmail(fd).subscribe(
    //     (res) => {
    //       console.log(res);
    //     },
    //     (err) => {
    //       console.log(err)
    //     }
    //   )
    // }
  }

  saveCorresActivity() {
    const postDataObj: ISaveCorrespondenceActivity = {
      applicationIds: this.candidateApplicationIds,
      processId: this.correspondenceDataObj.processId,
      activityId: this.correspondenceDataObj.activityId,
      comments: this.remarksInputValue,
      clause_id: this.clauseId,
      mailerID: 1010,
      // "clausMasterList": null,
      cc: this.ccInputValue,
      bcc: this.bccInputValue,
      templateId: this.templateId,
      mobileRequest: false,
      eventId: null,
      templateBody: this.bodyInputValue,
      templateSubject: this.subjectInputValue,
    };

    // if (this.fileData != null) {
    //   this.fileData.forEach(file => {
    //     fd.append('file[' + file.name + ']', file);

    //   });
    // }

    // console.log(fd)

    console.log(postDataObj);
    this.saveAttachment(
      this.correspondenceDataObj.applicationId,
      this.companyHiringType,
      this.correspondenceDataObj.activityId,
      postDataObj,
      null,
    );

    // this.activityService.saveCorrespondenceActivity(postDataObj).subscribe(
    //   data => {
    //     console.log(data);
    //     if (data.error === "failure") {
    //       precheck = false;
    //       let data1 = {
    //         msg: data.message,
    //         isSuccess: "error"

    //       }

    //       console.log(data);
    //       this.activityService.openSnackBar(data1, 'danger-snack');
    //     } else {
    //       precheck = true;
    //       this.saveAttachment(this.correspondenceDataObj.applicationId, this.companyHiringType, this.correspondenceDataObj.activityId);
    //       console.log("just before email service");

    //       let data1 = {
    //         msg: data.message,
    //         isSuccess: "created"
    //       }
    //       this.activityService.openSnackBar(data1, 'success-snack');
    //       if(!this.ifCoupled)
    //     {
    //     this.refreshcandiates.emit("true");
    //     }
    //     }
    //   },
    //   err => {
    //     let data1 = {
    //       msg: "Some error occurred",
    //       isSuccess: false

    //     }
    //     this.activityService.openSnackBar(data1, 'danger-snack');
    //     console.log('err-->', err);

    //   }
    // );

    // if (precheck) {
    //   //mailer integration
    //   for (let i = 0; i < this.candidateEmails.length; i++) {

    //     console.log("index of mail-->", i);
    //     const fd = new FormData();
    //     fd.append('from', 'talentacquisition@infosys.com')
    //     fd.append('subject', this.subjectInputValue);

    //     if (this.ccInputValue != null) {
    //       fd.append('ccArray', this.ccInputValue)
    //     }

    //     if (this.fileData != null) {
    //       this.fileData.forEach(file => {
    //         fd.append('file[' + file.name + ']', file);

    //       });
    //     }
    //     fd.append('to', this.candidateEmails[i]);
    //     let p = this.displayText(this.templateData[this.templateIndex].templateBody, i);
    //     fd.append('body', p)

    //     this.activityService.sendEmail(fd).subscribe(
    //       (res) => {
    //         console.log(res);
    //       },
    //       (err) => {
    //         console.log(err)
    //       }
    //     )
    //   }
    // }

    // this.showMoreLess();
  } // end of put

  mailServiceCall(postDataObj) {
    this.activityService.saveCorrespondenceActivity(postDataObj).subscribe(
      (data) => {
        console.log(data);
        if (data.error && data.error.toLowerCase() === 'failure') {
          const data1 = {
            msg: data.message,
            isSuccess: 'error',
          };

          console.log(data);
          this.activityService.openSnackBar(data1, 'danger-snack');
        } else {
          // this.saveAttachment(this.correspondenceDataObj.applicationId, this.companyHiringType, this.correspondenceDataObj.activityId);
          console.log('just before email service');

          const data1 = {
            msg: data.message,
            isSuccess: 'created',
          };
          this.activityService.openSnackBar(data1, 'success-snack');
          if (!this.ifCoupled) {
            this.refreshcandiates.emit('true');
          }
        }
      },
      (err) => {
        const data1 = {
          msg: 'Some error occurred',
          isSuccess: false,
        };
        this.activityService.openSnackBar(data1, 'danger-snack');
        console.log('err-->', err);
      },
    );
    this.showMoreLess();
  }

  editCorresActivity() {
    // to,cc,bcc,sub,body
    console.log('puting working');
    const Obj: CorrespondenceActivity = {
      applicationIds: this.correspondenceDataObj.applicationId,
      processId: this.correspondenceDataObj.processId,
      activityId: this.correspondenceDataObj.activityId,
      comments: this.remarksInputValue,
      clause_id: this.clauseId,
      mailerID: 1010,
      // "clausMasterList": null,
      cc: this.ccInputValue,
      bcc: this.bccInputValue,
      createdOn: this.correspondenceDataObj.createdOn,
      createdBy: this.correspondenceDataObj.createdBy,
      template_Id: this.templateId,
      templateBody: this.bodyInputValue,
      templateSubject: this.subjectInputValue,
      eventId: null,
      mobileRequest: false,
    };

    //  console.log(postDataObj);

    this.saveAttachment(
      this.correspondenceDataObj.applicationId,
      this.companyHiringType,
      this.correspondenceDataObj.activityId,
      null,
      Obj,
    );
  }
  editMailService(Obj) {
    this.activityService.editCorrespondenceActivity(Obj).subscribe(
      (data) => {
        console.log(data);
        // this.saveAttachment(this.correspondenceDataObj.applicationId, this.companyHiringType, this.correspondenceDataObj.activityId);
        const data1 = {
          msg: 'Saved Successfully',
          isSuccess: true,
        };
        this.activityService.openSnackBar(data1, 'success-snack');
      },
      (err) => {
        console.log('err-->', err);
        const data1 = {
          msg: err,
          isSuccess: false,
        };
        this.activityService.openSnackBar(data1, 'danger-snack');
      },
    );

    this.dialogRef.close();
  }

  deleteActivity() {}

  // file upload
  receiveFileOutput(filedata) {
    console.log('inside recievefile format');
    this.fileData = filedata['fileMerge1'];
    this.deletedFile = filedata['deletedFile1'];
  }

  saveAttachment(
    genericId,
    companyHiringTypeId,
    activityid,
    postDataObj?: ISaveCorrespondenceActivity,
    editObj?: CorrespondenceActivity,
  ) {
    console.log('inside saveattachmnt suitability');
    if (this.deletedFile && this.deletedFile.length > 0) {
      this.deletedFile.forEach((file) => {
        this.fileService.deleteFile(file.fileID).subscribe(
          (_res) => {},
          (_err) => {
            const data = {
              msg: 'Some error Occurred',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
          },
        );
      });
    }

    const activityId = activityid; //this.correspondenceDataObj.activityId;

    const fd = new FormData();
    fd.append('objectId', genericId);
    fd.append('objectType', 'AP');
    fd.append('attachmentId', '2');
    fd.append('companyHiringTypeId', companyHiringTypeId);
    fd.append('activityId', activityId);
    if (this.fileData && this.fileData.length > 0) {
      this.fileData.forEach((file) => {
        fd.append('file[' + file.name + ']', file);
      });
      console.log(fd);
      this.fileService.upload(fd).subscribe(
        (_res) => {},
        (_err) => {},
      );
    }
    if (this.editactivity) {
      this.editMailService(editObj);
    } else {
      if (postDataObj) {
        this.mailServiceCall(postDataObj);
      }
    }
  }

  //to replace placeholder

  displayText(text, index): string {
    console.log('text--->', text);
    console.log('index', index);
    console.log('displaytext', this.placeholderMapping);
    // if(this.interviewFlag)
    // {
    //    candidate = this.placeholderMappingInterview[index];
    // }
    // else{

    const candidate = this.placeholderMapping[0];

    // }
    console.log('x', candidate);
    const result = text.replace(/\<\<(.*?)\>\>/g, function (match, token) {
      return candidate[token];
    });
    console.log('result--->', result);
    return result;
  }

  setDisabled(formInvalid) {
    if (this.selectedTemplate !== -1 && !this.interviewFlag && !formInvalid) {
      return false;
    } else {
      return true;
    }
  }
}
